import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FieldLabel, FlexBox, FormField, FormGrid, Text, } from '@dixa/lib-shared-habla';
import _groupBy from 'lodash/groupBy';
import moment from 'moment-timezone';
import { analytics } from 'app/utils/segment';
import { getBusinessHoursString } from '../../../../../businesshours/utils/hours';
const weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
function getGroupedDays(schedule) {
    let index = 0;
    let currentKey = '';
    return _groupBy(schedule, (day) => {
        const intervalStr = getBusinessHoursString(day.intervals || []);
        const keyStr = `${index}-[${intervalStr}]`;
        if (keyStr !== currentKey) {
            index += 1;
            currentKey = `${index}-[${intervalStr}]`;
        }
        return currentKey;
    });
}
function getOpeningHours(schedule) {
    const groupedDays = getGroupedDays(schedule);
    return Object.values(groupedDays).map((days) => {
        const [firstDay] = days;
        const dayNames = days.map(({ date }) => weekdays[new Date(date).getDay()]);
        const isOnlyWeekdays = dayNames.length === 5 &&
            weekdays.slice(1, -1).every((day, index) => day === dayNames[index]);
        const isOnlyWeekend = dayNames.length === 2 &&
            [weekdays[6], weekdays[0]].every((day, index) => day === dayNames[index]);
        const day = {};
        if (isOnlyWeekdays) {
            day.name = 'Weekdays';
        }
        if (isOnlyWeekend) {
            day.name = 'Weekends';
        }
        if (!day.name) {
            const { 0: firstDay, [dayNames.length - 1]: lastDay } = dayNames;
            day.name = dayNames.length === 1 ? firstDay : `${firstDay} - ${lastDay}`;
        }
        day.hours = getBusinessHoursString(firstDay.intervals || []);
        return day;
    });
}
export function Overview({ schedule, timezone, onEdit }) {
    const openingHours = getOpeningHours(schedule);
    const timezoneOffset = moment.tz(timezone).format('Z');
    return (_jsxs(FormGrid, { children: [_jsxs(FormField, { children: [_jsx(FieldLabel, { children: "Timezone" }), _jsx(FlexBox, Object.assign({ background: "neutral.100", borderRadius: "100", padding: "300", margin: "200 0 0" }, { children: _jsxs(Text.Paragraph, Object.assign({ variant: "2" }, { children: [timezone, " (", timezoneOffset, ")"] })) }))] }), _jsxs(FormField, { children: [_jsx(FieldLabel, { children: "Current business hours" }), _jsxs(FlexBox, Object.assign({ background: "neutral.100", borderRadius: "100", padding: "300", margin: "200 0 0", alignItems: "center", justifyContent: "space-between", gap: "500" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "2" }, { children: openingHours.map(({ name, hours }, index, arr) => (_jsxs("span", { children: [name, ' ', _jsxs("strong", { children: [hours, index + 1 !== arr.length && ','] }), ' '] }, name))) })), _jsx(Button, Object.assign({ variant: "secondary", onClick: () => {
                                    analytics.businessHoursMigrationWizardEditHoursButtonClicked();
                                    onEdit();
                                } }, { children: "Edit hours" }))] }))] })] }));
}
